module.exports = global["angular"] = require("-!/Users/shamil/Projects/cian/cian/static/newbuild/node_modules/source-map-loader/index.js!/Users/shamil/Projects/cian/cian/static/newbuild/node_modules/angular/index.js");


//////////////////
// WEBPACK FOOTER
// ./~/angular/index.js
// module id = 42
// module chunks = 0